import { createRouter, createWebHistory } from 'vue-router'
import ConfigGate from '../components/ConfigGate.vue'
import DirectSite from '../components/DirectSite.vue'
import LandscapePage from '../components/LandscapePage.vue'

const routes = [
  {
    path: '/',
    name: 'ConfigGate',
    component: ConfigGate
  },
  {
    path: '/hello',
    name: 'HelloWorld',
    component: LandscapePage
  },
  {
    // Direct embed link (e.g. SharePoint): /<hash> loads a chatbot
    // configuration straight away, with no gate/login screen. <hash> is the
    // SHA-256 hex digest of the website's Firestore document ID — not the
    // raw ID itself — so the URL never exposes the real document ID.
    // Must stay last — vue-router still prefers the static routes
    // above for exact matches ('/', '/hello').
    path: '/:hash',
    name: 'DirectSite',
    component: DirectSite,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
